import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory}  from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import CarHorasSociales from "../element/CarHorasSociales";
import Menu from './Menu';
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// Contexto
import dataContext from "../context/User";
// Helper 
import GetFetch from '../helper/GetFetch';
// import ShortData from '../helper/ShortData';
import loadMenu from '../js/main';
import Footer from './Footer';

const HorasSociales = () => {

  const history = useHistory();

  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');
 
  const [horasSociales, setHorasSociales] = useState({});
  const [solvencia, setSolvencia] = useState();
  const [cargando, setCargando] = useState(true);

  useEffect(() => {

    if (datos) {
      let cred = JSON.parse(datos);
       dataUser.token = cred.token;
       dataUser.nombre = cred.nombre;
       dataUser.carnet = cred.carnet;
       dataUser.perfil = cred.perfil;
       dataUser.carrera = cred.carrera;

      let horasSocialesAlumno = GetFetch.horasSociales(cred.carnet, cred.token);      
      horasSocialesAlumno.then((dataHoras) => {
        setHorasSociales(dataHoras);
        if(localStorage.getItem('solvencia')){
          setSolvencia('INSOLVENTE')
          setTimeout(() => {
            localStorage.removeItem('solvencia')
          }, 5000);
        }
        setCargando(false);
        }).catch(() => setCargando(false));

      loadMenu();
    }else{
      history.push("/"); 
    }
  },[datos, history, dataUser]);

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto
            foto={dataUser.carnet}
            alt="Foto alumno"
            tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            perfil={dataUser.perfil}
            carrera={dataUser.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Horas sociales</h2>

        {cargando ? (
          <>
            <div className="esen-stat-grid">
              <SkeletonCard rows={1} title={false} />
            </div>
            <SkeletonCard rows={4} />
          </>
        ) : horasSociales.length > 0 ? (
          <>
            <div className="esen-stat-grid">
              <div className="esen-stat esen-stat--hero">
                <div>
                  <div className="esen-stat-value">
                    {horasSociales.reduce((total, element) => total + element.horas, 0)}
                  </div>
                  <div className="esen-stat-label">Total de horas sociales</div>
                </div>
              </div>
              <div className="esen-stat">
                <div>
                  <div className="esen-stat-value">{horasSociales.length}</div>
                  <div className="esen-stat-label">
                    {horasSociales.length === 1 ? 'Actividad registrada' : 'Actividades registradas'}
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Empresa</th>
                        <th scope="col">Actividad</th>
                        <th scope="col">Tipo de hora</th>
                        <th scope="col">Desde</th>
                        <th scope="col">Hasta</th>
                        <th scope="col">Horas</th>
                      </tr>
                    </thead>
                    <tbody>
                      {horasSociales.map((element, i) => (
                        <CarHorasSociales key={i} datos={element} />
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        ) : solvencia ? (
          <div className="alert alert-danger" role="alert">
            <i className="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
            <b>Insolvente.</b> Regulariza tus pagos para consultar tus horas sociales.
          </div>
        ) : (
          <EmptyState icon="fa-hourglass-half" title="Aún no tienes horas sociales registradas">
            Cuando completes actividades de servicio social, aparecerán en esta pantalla.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default HorasSociales;
